export default "__VITE_ASSET__kMBoYHMY__"